"use client";
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import React, { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

export type AllergensContentProps = {
  trigger: ReactNode;
  content: ReactNode;
};
export default function AllergensDesktop({
  trigger,
  content,
}: AllergensContentProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>{trigger}</TooltipTrigger>
        <TooltipContent side="right" className="p-0">
          {content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
